const PrivacyPolicy = () => {
    return (
        <>privacy policy</>
    );
}

export default PrivacyPolicy;